export function removeTMChar(text: string): string {
	return text.replace(/\u2122/g, '');
}
